<template>
  <el-dialog
    class="init-user-cert-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    top="25vh"
  >
    <el-form
      ref="editForm"
      :model="editForm"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
    >
      <!-- <el-form-item label="用户名称" prop="UserName">
        <el-input v-model="editForm.UserName" placeholder="请输入"></el-input>
      </el-form-item> -->
      <el-form-item label="用户身份标识（公钥）" prop="UserName" >
        <template slot="label">
          <span
            >用户身份标识（公钥）
            <el-tooltip class="item" effect="dark" placement="right">
              <i class="el-icon-question common-icon"></i>
              <div slot="content">
                <p>用于生成公钥的身份标识信息</p>
              </div>
            </el-tooltip>
          </span>
        </template>
        <el-input v-model="editForm.UserName"></el-input>
      </el-form-item>
      <el-form-item label="选择组织" prop="OrgId" >
        <el-select
          v-model="editForm.OrgId"
          placeholder="请选择"
          clearable
          class="auto-width"
          @change="handleSelect"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.OrgName"
            :value="item.OrgId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户角色" prop="Role" >
        <el-select v-model="editForm.Role" placeholder="请选择" clearable class="auto-width">
          <el-option
            v-for="item in roleOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleOk()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'InitUserCert',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 200
  },
  data() {
    return {
      disabled: false,
      title: '申请IBC用户证书',
      dialogVisible: false,
      editForm: {
        OrgId: '',
        OrgName: '',
        Role: '',
        UserName: '',
        Type: 2
      },
      editRules: {
        UserName: [{ required: true, message: '请填写用户身份标识（公钥）', trigger: 'blur' }],
        OrgId: [{ required: true, message: '请选择组织', trigger: 'blur' }],
        Role: [{ required: true, message: '请选择用户角色', trigger: 'blur' }]
      },
      options: [],
      roleOptions: [
        { label: '管理员用户', value: 2 },
        { label: '普通用户', value: 3 }
      ],
      adaptationVars: {
        formLabelWidth: 200
      }
    }
  },
  methods: {
    getOptions() {
      this.$apis.certificate.getOrgList({ limit: 50, offset: 0, certType: 0 }).then(res => {
        if (res.data && res.data.items) {
          this.options = res.data.items
        }
      })
    },
    handleCancel() {
      this.editForm = {
        OrgId: '',
        OrgName: '',
        Role: '',
        UserName: '',
        Type: 2
      }
      this.disabled = false
      this.$refs.editForm.clearValidate()
      this.dialogVisible = false
    },
    handleOpen() {
      this.getOptions()
      this.dialogVisible = true
    },
    handleSelect(val) {
      let item = this.options.filter(ele => ele.OrgId === val)
      this.editForm.OrgName = item[0]['OrgName'] || ''
    },
    handleOk() {
      const testResult = this.$utils.checkCertificateName(this.editForm.UserName)
      if (testResult) {
        this.$message.error(testResult)
        return
      }
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$apis.certificate
            .initUser(this.editForm)
            .then(res => {
              this.$message.success('申请用户证书成功！')
              this.$emit('update:list')
              this.handleCancel()
            })
            .catch(err => {
              this.disabled = false
              return
            })
        } else {
          this.$message.warning('请填写内容')
          this.disabled = false
          return
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.init-user-cert-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }

  .common-icon {
    vertical-align: middle;
    font-size: var(--common-dialogize);
  }
}
</style>
